<template>
  <div class="survey">
    <form
      v-show="!submitted"
      class="form survey"
      @submit.prevent="submitSurvey()"
    >
      <p>
        <b
          >This app is being developed by Soldier-Coders. Your feedback is
          valuable to make the project a success and modernize the face of Army
          Maintenance</b
        >
      </p>
      <div class="separator"></div>
      <p>
        Please <b>rate</b> your overall satisfaction with the addition of
        <b>PMCSx</b> to your maintenance activities
      </p>
      <Rating v-model="rating" :cancel="false" />
      <div class="p-field-checkbox">
        <Checkbox id="recommended" v-model="recommended" :binary="true" />
        <label for="recommended"
          >I think the addition of a chat forum would be valuable</label
        >
      </div>
      <div class="p-field-checkbox">
        <Checkbox id="inclined" v-model="inclined" :binary="true" />
        <label for="inclined"
          >Becuase of this app, I am more inclined to accuratly report my
          maintenace concerns.</label
        >
      </div>
      <div class="separator"></div>
      <p>
        Please provide your comments to improve your PMCSx experience. Your
        feedback is being collected for
        <b
          >consideration at the DA level, will help develop the Artificial
          Intelligence to make GCSS-Army better!
        </b>
      </p>
      <Textarea v-model="comments" :autoResize="true" rows="5" cols="30" />
      <Button class="p-m-3 p-shadow-8" label="Submit Feedback" type="submit" />
    </form>
    <div v-show="submitted">
      <p>Thanks for the feedback!</p>
      <p>You rock!</p>
    </div>
  </div>
</template>

<script>
import { fb_db, fb_auth, fs, fb_survey } from "../firebase";
import Rating from "primevue/rating";
import Checkbox from "primevue/checkbox";
import Textarea from "primevue/textarea";

export default {
  name: "Survey",
  components: {
    Rating,
    Textarea,
    Checkbox,
  },
  data() {
    return {
      rating: null,
      inclined: false,
      recommended: false,
      comments: null,
      submitted: false,
    };
  },
  methods: {
    submitSurvey() {
      fb_survey
        .add({
          rating: this.rating,
          inclined: this.inclined,
          recommended: this.recommended,
          comments: this.comments,
          user: fb_db.collection("users").doc(fb_auth.currentUser.uid),
        })
        .then(() => {
          this.submitted = true;
        });
    },
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    userProfile() {
      return this.$store.state.userProfile;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/theme.scss";

.survey {
  padding: 10px;
}

.separator {
  width: 80%;
  height: 2px;
  background: #ffc400;
  margin: 15px 0px 30px 10%;
}

.p-field-checkbox {
  text-align: left;
  margin: 20px;
}
</style>